import { useEffect, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import NavGroup from './NavGroup';
import { NavItemType } from 'types/menu';

interface MenuData {
  drawerOpen?: boolean;
  items?: NavItemType[];
}

function sanitizeMenuItems(items: NavItemType[] = []): NavItemType[] {
  return items.map((item) => {
    const nextItem: NavItemType = { ...item };
    const url = typeof nextItem.url === 'string' ? nextItem.url.trim() : '';
    if (url && /(^|\/)(undefined|null)(\/|$|[?#])/i.test(url)) {
      nextItem.url = undefined;
    }
    if (Array.isArray(nextItem.children)) {
      nextItem.children = sanitizeMenuItems(nextItem.children);
    }
    return nextItem;
  });
}

function getMenuFromStorage(): MenuData {
  if (typeof window === 'undefined') return {};
  try {
    const raw = localStorage.getItem('loginMenu');
    if (!raw) return {};
    const parsed = JSON.parse(raw) as MenuData;
    const sanitizedItems = sanitizeMenuItems(parsed?.items);
    localStorage.setItem('loginMenu', JSON.stringify({ ...parsed, items: sanitizedItems }));
    return {
      ...parsed,
      items: sanitizedItems
    };
  } catch {
    return {};
  }
}

function collectIds(items: NavItemType[] | undefined, result: string[] = []): string[] {
  items?.forEach((item) => {
    if (item.id) result.push(item.id);
    if (item.children) collectIds(item.children, result);
  });
  return result;
}

const Navigation = () => {
  const menu = useMemo(() => getMenuFromStorage(), []);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && menu?.items) {
      const ids = collectIds(menu.items);
    }
  }, [menu]);

  const navGroups = menu?.items?.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: menu.drawerOpen ? 2 : 0, '& > ul:first-of-type': { mt: 0 } }}>{navGroups}</Box>;
};

export default Navigation;
